var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clickable"},[_c('rir-icon',{attrs:{"icon":_vm.item.editing ? 'save' : 'edit'},nativeOn:{"click":function($event){return _vm.goEdit($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }